import { render, staticRenderFns } from "./DiffDossiers.vue?vue&type=template&id=368dd618&"
import script from "./DiffDossiers.vue?vue&type=script&lang=js&"
export * from "./DiffDossiers.vue?vue&type=script&lang=js&"
import style0 from "./DiffDossiers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports